import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ConnectionTestModal = ({ isOpen, isLoading, result, onClose, onRetry }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-surface border border-border rounded-lg p-6 w-full max-w-md shadow-elevated">
        <div className="text-center mb-6">
          <h3 className="text-lg font-semibold text-text-primary mb-2">
            Prueba de Conexión
          </h3>
          
          {isLoading && (
            <div className="space-y-4">
              <div className="flex justify-center">
                <div className="w-8 h-8 border-4 border-primary/30 border-t-primary rounded-full animate-spin"></div>
              </div>
              <p className="text-text-secondary">
                Estableciendo conexión con la base de datos...
              </p>
            </div>
          )}

          {!isLoading && result && (
            <div className="space-y-4">
              <div className={`w-12 h-12 rounded-full flex items-center justify-center mx-auto ${
                result?.success ? 'bg-success/10' : 'bg-error/10'
              }`}>
                <Icon 
                  name={result?.success ? "CheckCircle" : "XCircle"} 
                  size={24} 
                  className={result?.success ? 'text-success' : 'text-error'}
                />
              </div>

              <div>
                <h4 className={`font-medium mb-2 ${
                  result?.success ? 'text-success' : 'text-error'
                }`}>
                  {result?.success ? '¡Conexión Exitosa!' : 'Error de Conexión'}
                </h4>
                <p className="text-text-secondary text-sm">
                  {result?.message}
                </p>
              </div>

              {result?.success && result?.details && (
                <div className="bg-muted rounded-lg p-3 text-left">
                  <h5 className="font-medium text-text-primary mb-2">
                    Detalles de la Conexión
                  </h5>
                  <div className="text-sm space-y-1">
                    <p>
                      <span className="text-text-secondary">Latencia:</span>{' '}
                      <span className="text-text-primary">{result?.latency}ms</span>
                    </p>
                    <p>
                      <span className="text-text-secondary">Servidor:</span>{' '}
                      <span className="text-text-primary">{result?.details?.serverVersion}</span>
                    </p>
                    <p>
                      <span className="text-text-secondary">Conexiones:</span>{' '}
                      <span className="text-text-primary">
                        {result?.details?.currentConnections}/{result?.details?.maxConnections}
                      </span>
                    </p>
                  </div>
                </div>
              )}

              {!result?.success && result?.error && (
                <div className="bg-error/10 rounded-lg p-3 text-left">
                  <h5 className="font-medium text-error mb-1">Error Técnico</h5>
                  <p className="text-sm text-text-secondary">{result?.error}</p>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="flex gap-3">
          {!isLoading && result && !result?.success && (
            <Button variant="outline" onClick={onRetry} className="flex-1">
              <Icon name="RotateCcw" size={16} className="mr-2" />
              Reintentar
            </Button>
          )}
          
          <Button 
            variant={!isLoading && result?.success ? "default" : "outline"} 
            onClick={onClose}
            className="flex-1"
            disabled={isLoading}
          >
            {!isLoading && result?.success ? 'Continuar' : 'Cerrar'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConnectionTestModal;